import useErrorMessageHandler from '@/@core/helpers/errorMessageHandler';
import { useCallApi } from '@/@core/services/axiosCall';
import {
  reactive,
  Ref,
  ref,
  toRefs,
  unref
} from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useUnitStore = defineStore('unit', () => {
  const state = reactive({
    total: 0,
    units: []
  });

  async function getManyUnit() {
    const { errorMessage, result, error } = await useCallApi({
      method: 'get',
      url: '/units'
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    state.units = result.units;
    state.total = result.count;

    return result;
  }

  async function postUnit(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'post',
      url: '/units',
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function putUnit(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'put',
      url: '/units/' + data.id,
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function deleteUnit(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'delete',
      url: '/units/' + data.id
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }
  return {
    ...toRefs(state),
    getManyUnit,
    postUnit,
    deleteUnit,
    putUnit
  };
});
